import ProjectInfo from "./projectInfo";

export default class ProjectCollectionInfo {
  public idProjectCollection: number = 0;
  public collectionName: string = "";
  public projects: ProjectInfo[] = [];
}
